import React from 'react';
export const Section = ({ id, className, children, }) => {
    return (React.createElement("section", { id: id },
        React.createElement("div", { className: className || 'form-content' }, children)));
};
//# sourceMappingURL=Section.js.map